<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Report Service Compensate Codes</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true" v-model="from" label="Date From" />
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true"  v-model="to" label="Date To" />
                    </div>
                </mdb-col>
                <mdb-col md="6">
                    <mdb-btn @click="getData()" v-if="!loading" outline="primary"><mdb-icon icon="search" /> Search</mdb-btn>
                    <mdb-spinner small v-if="loading" />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <input v-on:keyup.enter="startSearch" v-model="search" type="text" placeholder="#Customer Name/Phone" class="form-control">
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <select v-model="selected_payment_method" class="browser-default custom-select">
                        <option value="" selected>All Payment Methods</option>
                        <option v-for="payment in payment_methods" :key="payment" :value="payment">{{payment}}</option>
                    </select>
                </mdb-col>
                <mdb-col md="3">
                    <select v-model="selected_compensate_code" class="browser-default custom-select">
                        <option value="" selected>All Compensate Codes</option>
                        <option v-for="code in compensate_codes" :key="code" :value="code">{{code}}</option>
                    </select>
                </mdb-col>
            </mdb-row>
            <div v-if="loading">Wait.. Processing dont panic...</div>
            <mdb-tbl responsive striped v-if="!loading">
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th>Customer</th>
                    <th>Compensate Code</th>
                    <th>Status</th>
                    <th>Payment</th>
                    <th>Given By</th>
                    <th>Date Time</th>
                    <th>Action</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr style="cursor: pointer" v-for="(record, index) in records" :key="record.id">
                    <td>{{index+1}}</td>
                    <td>
                      <div class="screen-link" @click="navigateToUser(record.customer.phone_number)">{{record.customer.name}}</div>
                      <div>{{record.customer.phone_number}}</div>
                    </td>
                    <td>
                        <div>{{record.promo_code_config.code}}</div>
                        <div class="font-weight-bold">RM {{record.promo_code_config.amount}}</div>
                    </td>
                    <td>
                        <div>{{record.service_order.order_number}}</div>
                        <div class="text-success" v-if="record.user_join_promo_code_config.used_at">Used: {{record.user_join_promo_code_config.used_at}}</div>
                        <div>Expired: {{record.user_join_promo_code_config.expired_at}}</div>
                    </td>
                    <td>
                        <div>{{record.service_order.service_charge.payment_type}}</div>
                        <div style="text-decoration: line-through;" v-if="record.service_order.service_charge.subtotal != record.service_order.service_charge.grand_total">RM {{record.service_order.service_charge.subtotal}}</div>
                        <div>RM {{record.service_order.service_charge.grand_total}}</div>
                    </td>
                    <td>{{record.admin.name}}</td>
                    <td>
                        <div>{{momentFormat16(record.created_at)}}</div>
                        <div class="text-success" v-if="record.service_order.date_complete">{{momentFormat(record.service_order.date_complete)}}</div>
                        <div class="text-danger" v-if="record.service_order.time_cancel_job">{{momentFormat(record.service_order.time_cancel_job)}}</div>
                    </td>
                    <td>
                        <mdb-btn @click="showOrderDetail(record)" color="primary" size="sm"><mdb-icon far icon="eye" /></mdb-btn>
                    </td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
        </mdb-container>
        <OrderDetailComponent :id="focus_order_id" :visible="order_detail_component" :close="closeOrderDetailComponent" :callback="callback" />
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbDatePicker, mdbBtn, mdbSpinner ,mdbTbl, mdbTblHead, mdbTblBody, mdbIcon } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {momentFormat16, momentFormat, checkPermissionsBinary} from '../js/helper';
import OrderDetailComponent from '../components/OrderDetailComponent';

export default {
  name: 'report_service_compensate_codes',
  components: {
    mdbContainer,mdbRow, mdbCol, mdbDatePicker, mdbBtn, mdbSpinner,
    AppNavigation, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon, OrderDetailComponent
  },
  data: ()=>({
    loading:false,
    from: "",
    to: "",
    records: [],
    all_records: [],
    total_records: 0,
    focus_order_id: 0,
    order_detail_component: false,

    payment_methods: [],
    compensate_codes: [],
    selected_payment_method: "",
    selected_compensate_code: "",
    search: "",
  }),
  methods: {
      getData(){
        if(this.loading){
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/get_report_service_compensate_codes",
            data: {
                from: this.from,
                to: this.to
            },
            complete: ()=>this.loading=false,
            success: result=>{
                let compensate_codes=new Set();
                let payment_methods=new Set();
                result.data.forEach(element => {
                    compensate_codes.add(element.promo_code_config.code);
                    payment_methods.add(element.service_order.service_charge.payment_type);
                });
                this.compensate_codes=compensate_codes;
                this.payment_methods=payment_methods;
                this.records=result.data;
                this.total_records=result.data.length;
                this.all_records=result.data;
            },
        }, this)
      },
      momentFormat16(date){
          return momentFormat16(date);
      },
      momentFormat(date){
          return momentFormat(date);
      },
      closeOrderDetailComponent(){
          this.order_detail_component=false;
      },
      callback(){
          this.getData();
      },
      showOrderDetail(record){
          this.focus_order_id=record.service_order.id;
          this.order_detail_component=true;
      },
      startSearch(){
          this.selected_compensate_code="";
          this.selected_payment_method="";
          if(this.search==""){
            this.records=[...this.all_records];
            return false;
          }
          let temp_records=new Set();
          this.all_records.forEach(element=>{
            let compare_1=element.customer.name;
            compare_1=compare_1.toUpperCase();
            let keyword=this.search;
            keyword=keyword.toUpperCase();
            if(compare_1.indexOf(keyword) > -1){
                temp_records.add(element);
            }
            if(element.customer.phone_number.indexOf(keyword) > -1){
                temp_records.add(element);
            }
          })
          this.records=[...temp_records];
      },
        navigateToUser(phone){
            if(checkPermissionsBinary(3, this.$store.state.permissions)){
                this.$router.push({ name: 'users', params: {phone: phone}});
            }
        },
        permissionCheck(permission){
            return checkPermissionsBinary(permission, this.$store.state.permissions);
        },
  },
  mounted: function(){
    let date = new Date();
    let month = date.getMonth()+1;
    this.from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.getData();
  },
  watch:{
      selected_payment_method(){
        if(this.selected_payment_method || this.selected_compensate_code){
            let temp_records=new Set();
            this.all_records.forEach(element=>{
                if(this.selected_payment_method && this.selected_compensate_code){
                    if(element.service_order.service_charge.payment_type==this.selected_payment_method && element.promo_code_config.code==this.selected_compensate_code){
                        temp_records.add(element);
                    }
                }else
                if(this.selected_payment_method){
                    if(element.service_order.service_charge.payment_type==this.selected_payment_method){
                        temp_records.add(element);
                    }
                }else
                if(this.selected_compensate_code){
                    if(element.promo_code_config.code==this.selected_compensate_code){
                        temp_records.add(element);
                    }
                }
            })
            this.records=[...temp_records];
        }else{
            this.records=this.all_records;
        } 
      },
      selected_compensate_code(){
        if(this.selected_payment_method || this.selected_compensate_code){
            let temp_records=new Set();
            this.all_records.forEach(element=>{
                if(this.selected_payment_method && this.selected_compensate_code){
                    if(element.service_order.service_charge.payment_type==this.selected_payment_method && element.promo_code_config.code==this.selected_compensate_code){
                        temp_records.add(element);
                    }
                }else
                if(this.selected_payment_method){
                    if(element.service_order.service_charge.payment_type==this.selected_payment_method){
                        temp_records.add(element);
                    }
                }else
                if(this.selected_compensate_code){
                    if(element.promo_code_config.code==this.selected_compensate_code){
                        temp_records.add(element);
                    }
                }
            })
            this.records=[...temp_records];
        }else{
            this.records=this.all_records;
        } 
      }
  }
}
</script>

<style scoped>
.screen-link:hover{
  color: #4285F4;
  font-weight: bold;
  cursor: pointer;
}
</style>